export * from "./base";
export * from "./constants.generated";

export { pipedriveClientV1 } from "./v1";
export type { PathsV1 } from "./v1";

export { pipedriveClient } from "./v2";
export type { paths } from "./v2";
